import { useContracts } from '@/services/contract/useContracts';
import { useSystemSettings } from '@/services/settings/SystemSettingsProvider';
import { useSkills } from '@/services/tasks/useSkills';
import { useTasks } from '@/services/tasks/useTasks';
import { useMemo } from 'react';
import { useAllEmployeeOptions } from '../../pages/roster/hooks/useAllEmployeeOptions';
import { BaseWarningsProps } from './warnings.types';
import { strings } from './warningsStrings';

export const useBaseWarningProps = () => {
  const { homeEmployees, awayEmployees, employeesSkillsList } = useAllEmployeeOptions();
  const { contracts } = useContracts();
  const skills = useSkills();
  const tasks = useTasks();
  const validationSettings = useSystemSettings(s => s.settings.rosterValidation);
  const splitShiftSettings = useSystemSettings(s => s.settings.splitShifts);
  const breakSettings = useSystemSettings(s => s.settings.breakSettings);

  return useMemo(() => {
    const allEmployees = [...homeEmployees, ...awayEmployees];

    const baseProps: BaseWarningsProps = {
      allEmployees,
      employeesSkillsList,
      skills,
      tasks,
      validationSettings,
      splitShiftSettings,
      breakSettings,
      contracts,
      strings
    };

    return baseProps;
  }, [
    homeEmployees,
    awayEmployees,
    employeesSkillsList,
    skills,
    tasks,
    validationSettings,
    splitShiftSettings
  ]);
};
